<div class="row" *ngIf="isVisible">
    <div [ngClass]="isEditStop||isAddStop||isShiftStop ? 'col-sm-6' : 'col-sm-12'">
        <kendo-grid #stopsGrid
                    [data]="stopView"
                    [pageSize]="stopState.take"
                    [sortable]="false"
                    [pageable]="pageable"
                    [filterable]="false"
                    [resizable]="true"
                    (dataStateChange)="stopDataStateChange($event)"
                    [style.maxHeight.px]="height"
                    [rowClass]="stopRowCallback"
                    (edit)="stopEditHandler($event)"
                    (remove)="stopRemoveHandler($event)"
                    (cancel)="stopCancelHandler($event)"
                    (save)="stopSaveHandler($event)">
            <kendo-grid-column title="Action" width="85" [hidden]="!isBlankActionColumn"></kendo-grid-column>
            <kendo-grid-command-column title="Action" width="105" [hidden]="columns.indexOf('action')<0" *showRolesIf="'Account Manager,Carrier Sales Rep,Track and Trace'">
                <ng-template kendoGridHeaderTemplate let-dataItem>
                    <div *ngIf="pageType=='orderentry'&&dataItem.invoiceStatusName!='Prepared'&&readonly!=true">
                        <a [routerLink]="" (click)="isSplit=!isSplit;isAddStop=false" class="h2 m-2" title="Split Load" tabindex="-1">
                            <i class="fas" [ngClass]="isSplit ? 'text-success fa-toggle-on' : 'text-secondary fa-toggle-off'"></i>
                            <span class="h5 m-2">Split Load</span>
                        </a>
                        <br />
                        <a [routerLink]="" (click)="isAddStop=!isAddStop;isSplit=false" class="h2 m-2" title="Add Stop" tabindex="-1">
                            <i class="fas" [ngClass]="isAddStop ? 'text-success fa-toggle-on' : 'text-secondary fa-toggle-off'"></i>
                            <span class="h5 m-2">Add Stop</span>
                        </a>
                        <!--<button class="btn btn-sm m-2" [ngClass]="isSplit ? 'btn-secondary' : 'btn-success'"
                                title="Split Load" tabindex="-1" (click)="isSplit=!isSplit">
                            <i class="fas" [ngClass]="isSplit ? 'fa-toggle-on' : 'fa-toggle-off'"></i>
                        </button>
                        <button class="btn btn-sm m-2" [ngClass]="isAddStop ? 'btn-secondary' : 'btn-success'" title="Add Stop" tabindex="-1" (click)="isAddStop=!isAddStop"><i class="fas" [ngClass]="isAddStop ? 'fa-toggle-on' : 'fa-toggle-off'"></i></button>-->
                    </div>
                </ng-template>
                <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem="dataItem">
                    <span *ngIf="readonly != true">
                        <button class="btn btn-sm btn-success m-1" title="Edit" tabindex="-1" *ngIf="canEditStop(dataItem)" (click)="editOrderStop(dataItem)"><i class="fas fa-pencil-alt"></i></button>
                    </span>
                    <span *ngIf="dataItem.invoiceStatusName != 'Prepared' && readonly != true">
                        <!--<button kendoGridEditCommand type="button" [primary]="true" *ngIf="dataItem.arrivedInd!=true&&dataItem.departedInd!=true">Edit</button>-->
                        <!--<input type="button" value="Edit" class="btn btn-primary" *ngIf="!isSplit&&!isAddStop&&dataItem.arrivedInd!=true&&dataItem.departedInd!=true" (click)="editOrderStop(dataItem)" />-->
                        <button class="btn btn-sm btn-secondary m-1" title="Shift Stop Times" tabindex="-1" *ngIf="canShiftStop(dataItem)" (click)="shiftOrderStop(dataItem)"><i class="fas fa-clock"></i></button>
                        <button class="btn btn-sm btn-danger m-1" title="Delete Split" tabindex="-1" *ngIf="canDeleteSplit(dataItem)" (click)="deleteSplit(dataItem)"><i class="fas fa-times"></i>&nbsp;<i class="fas fa-code-branch"></i></button>
                        <button class="btn btn-sm btn-danger m-1" title="Delete" tabindex="-1" *ngIf="canDeleteStop(dataItem)" (click)="deleteOrderStop(dataItem)"><i class="fas fa-times"></i></button>
                        <!--<button kendoGridSaveCommand type="button" [primary]="true" [disabled]="!isStopValid">Save</button>-->
                        <!--<input type="button" value="Split Load After" class="btn btn-primary" *ngIf="pageType=='orderentry'" (click)="splitLoad(dataItem)" />-->
                        <button class="btn btn-sm btn-primary m-1" title="Split Load After" tabindex="-1" *ngIf="canSplitAfter(dataItem)" (click)="splitLoad(dataItem)"><i class="fas fa-code-branch"></i></button>
                        <button class="btn btn-sm btn-primary m-1" title="Add Stop Before" tabindex="-1" *ngIf="isAddStop&&dataItem.legNumber==1&&dataItem.stopSequence==1" (click)="addStop(dataItem,'before')"><i class="fas fa-plus"></i><i class="fas fa-level-up-alt"></i></button>
                        <br />
                        <button class="btn btn-sm btn-primary m-1" title="Add Stop After" tabindex="-1" *ngIf="isAddStop&&dataItem.eventCode!='DLT'" (click)="addStop(dataItem,'after')"><i class="fas fa-plus"></i><i class="fas fa-level-down-alt"></i></button>
                        <button kendoGridCancelCommand type="button">Cancel</button>
                        <!--<span *showRolesIf="'Track and Trace'">
                            <button kendoGridRemoveCommand *ngIf="canUnactualizeStop(dataItem)">Unactualize {{ dataItem.eventCode=='BMT' ? '' : (dataItem.departedInd==true ? 'Dep' : 'Arv') }}</button>
                        </span>-->
                        <button class="m-1" kendoGridRemoveCommand *ngIf="canUnactualizeStop(dataItem)">Unactualize {{ dataItem.eventCode=='BMT' ? '' : (dataItem.departedInd==true ? 'Dep' : 'Arv') }}</button>
                    </span>
                    <div *ngIf="readonly != true && isSysAdmin">
                        <button class="btn btn-sm btn-primary m-1" title="Move Down" tabindex="-1" *ngIf="canMoveUp(dataItem)" (click)="moveStopUp(dataItem)"><i class="fas fa-arrow-up"></i></button>
                        <button class="btn btn-sm btn-primary m-1" title="Move Down" tabindex="-1" *ngIf="canMoveDown(dataItem)" (click)="moveStopDown(dataItem)"><i class="fas fa-arrow-down"></i></button>
                    </div>
                </ng-template>
            </kendo-grid-command-column>
            <kendo-grid-column title="Event" width="75" *ngIf="columns.indexOf('event')>=0">
                <ng-template kendoGridCellTemplate let-stop>
                    <div class="h4">
                        <span class="badge" [ngClass]="{'bg-info': stop.legNumber % 2 == 1, 'bg-secondary': stop.legNumber % 2 == 0}">Load #{{stop.legNumber}}</span>
                        <div class="h5">{{stop.eventCode}}</div>
                    </div>
                    <div *ngIf="stop.hasAppointment == true" class="text-danger"><i class="fas fa-calendar-check"></i> Appt</div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Customer/Location" width="175" [resizable]="false" *ngIf="columns.indexOf('customer')>=0">
                <ng-template kendoGridCellTemplate let-stop>
                    <span *ngIf="stop.customerID>0">
                        <a target="_blank" [routerLink]="['/customer-detail', stop.customerCode]" tabindex="-1">{{stop.stopCustomer}}</a><br />
                        <a target="_blank" [routerLink]="['/customer-detail', stop.customerCode]" tabindex="-1">{{stop.customerCode}}</a><br />
                        <span *ngIf="stop.customerAddress!=null">{{stop.customerAddress}}<br /></span>
                    </span>
                    {{stop.cityStateZip}}<br />
                    {{stop.customerTimeZoneName}}<br />
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="miles" title="Miles" width="75" [resizable]="false" *ngIf="columns.indexOf('miles')>=0"></kendo-grid-column>
            <kendo-grid-column title="Carrier" width="175" [hidden]="isHideCarrierColumn" *ngIf="columns.indexOf('carrier')>=0">
                <ng-template kendoGridCellTemplate let-stop>
                    <div *ngIf="stop.carrier != null && stop.carrier.length > 0">
                        <a target="_blank" [routerLink]="['/carrier-detail', stop.carrierCode]">
                            {{stop.carrierCode}}
                        </a>
                        <br />
                        <a target="_blank" [routerLink]="['/carrier-detail', stop.carrierCode]">
                            {{stop.carrier}}
                        </a>
                    </div>
                    <div *ngIf="stop.driver != null && stop.driver.length > 0">
                        {{stop.driver}}: {{stop.driverCell}}
                    </div>
                    <div>CSR: {{stop.csr}}</div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Planned" width="100" *ngIf="columns.indexOf('planned')>=0">
                <ng-template kendoGridCellTemplate let-stop>
                    <span *ngIf="stop.eventCode!='BMT'">
                        {{stop.earliestDate | date: 'M/dd/yy HH:mm'}} -
                        <br />
                    </span>
                    {{stop.latestDate | date: 'M/dd/yy HH:mm'}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Actual Arrival/Departure" width="150" *ngIf="columns.indexOf('actual')>=0">
                <ng-template kendoGridCellTemplate let-stop>
                    <div *ngIf="stop.eventCode!='BMT'">Arrival: {{stop.arrivalDate | date: 'M/dd/yy HH:mm'}} - {{stop.arrivedInd ? 'A' : 'E'}}</div>
                    <div>Depart: {{stop.departDate | date: 'M/dd/yy HH:mm'}} - {{stop.departedInd ? 'A' : 'E'}}</div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Freight" width="125" *ngIf="columns.indexOf('freight')>=0">
                <ng-template kendoGridCellTemplate let-stop>
                    <div><b>Pcs</b>: {{stop.pieces}} - {{stop.confirmedFreight ? '' : 'E'}} {{stop.piecesUnitCode}}</div>
                    <div><b>Wgt</b>: {{stop.weight}} - {{stop.confirmedFreight ? '' : 'E'}} {{stop.weightUnitCode}}</div>
                    <div *ngIf="stop.commodityName != null && stop.commodityName != ''"><b>Commodity</b>: {{stop.commodityName}}</div>
                    <!--<li *ngIf="stop.commodityDescription != null && stop.commodityDescription != '' && (stop.commodityNotes == null || stop.commodityNotes == '')">Commodity: {{stop.commodityDescription}}</li>-->
                    <div *ngIf="stop.commodityNotes != null && stop.commodityNotes != ''"><b>Notes</b>: {{stop.commodityNotes}}</div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Ref #" width="100" *ngIf="columns.indexOf('refnum')>=0">
                <!--[resizable]="false"-->
                <ng-template kendoGridCellTemplate let-stop>
                    <div [innerHtml]="getReferenceNumbers(stop.referenceNumbers)"></div>
                    <div *ngIf="stop.eventCode == 'LUL' && stop.podName != null && stop.podName.length > 1">
                        <b>POD Name</b>: {{stop.podName}}
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Instructions" width="125" *ngIf="columns.indexOf('instructions')>=0">
                <ng-template kendoGridCellTemplate let-stop>
                    {{stop.instructions}}
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>

    <div class="col-sm-6" *ngIf="isShiftStop">
        <div class="row">
            <div class="col">
                <h3>Shift Stop Time</h3>
                <p>This will shift the time for this stop, future stops, and associated tracking events if applicable.</p>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <label class="fw-bold"># Days:</label>
                <input type="number" class="form-control" name="shiftDays" step="1" [(ngModel)]="shiftDays" />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <label class="fw-bold"># Hours:</label>
                <input type="number" class="form-control" name="shiftHours" step="1" [(ngModel)]="shiftHours" />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 text-end">
                <button type="button" class="btn btn-primary" (click)="shiftOrderStopSave()">Save</button>
                <button type="button" class="btn btn-secondary" (click)="cancelEdit()">Cancel</button>
            </div>
        </div>
    </div>

    <div class="col-sm-6" *ngIf="isEditStop || isAddStop && ((newStop | json) != '{}')">
        <!-- Edit Stop form -->
        <order-stop-form [newStop]="newStop" [pageType]="pageType" [orderStopID]="orderStopID" (onCancel)="cancelEdit()" (onRefresh)="refreshAfterEdit()"></order-stop-form>
    </div>
</div>
